import { useInitSession } from '@btime/react-session'
import { useMutation, gql } from '@apollo/client'
import { navigate } from '@reach/router'

import { getSubdomain } from '../../../../utils/helpers/url'
import { sessionsClient } from '../../../../utils/apollo/api'
import * as tracker from '@btime/tracker'

const MUTATION = gql`
  mutation login($session_reference: String) {
    login(input: { session_reference: $session_reference }, origin: "web", repleace_session: true) {
      token
      permissions {
        enabled
        name
      }
      user {
        id
        name
        email
        master
        canAccessPaymentModule
      }
    }
  }
`

const useOAuthLoginRequest = session_reference => {
  const [request, state] = useMutation(MUTATION, { client: sessionsClient })
  const initSession = useInitSession()

  const handleRequest = async () => {
    return request({ variables: { session_reference } }).then(resp => {
      if (!resp.errors) {
        const session = resp.data.login
        const workspace = getSubdomain()
        initSession({ ...session, workspace })
        tracker.signIn(session.user, workspace)

        navigate('/')
      }
    })
  }

  return [handleRequest, state]
}

export default useOAuthLoginRequest
